import { render } from "./QuestionsDependents.vue?vue&type=template&id=5bc4f9d1"
import script from "./QuestionsDependents.vue?vue&type=script&lang=js"
export * from "./QuestionsDependents.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__